<template>
  <div class="filter-panel mdl-grid" role="group" :aria-label="panelLabel || undefined">
    <slot />
    <div v-if="showReset" class="filter-panel__actions mdl-cell mdl-cell--2-col mdl-cell--12-col-phone flex justify-end">
      <ActionButton
        custom-class="cdlButton filter-panel__reset"
        size="small"
        :disabled="!hasActiveFilters"
        @click="$emit('reset')"
      >{{ resetLabel }}</ActionButton>
    </div>
  </div>
</template>

<script setup>
import ActionButton from '@/components/Primitives/Buttons/ActionButton.vue'

defineProps({
  resetLabel: {
    type: String,
    default: 'Reset'
  },
  hasActiveFilters: {
    type: Boolean,
    default: false
  },
  panelLabel: {
    type: String,
    default: ''
  },
  showReset: {
    type: Boolean,
    default: true
  }
})

defineEmits(['reset'])
</script>

<style scoped>
/* $spacingFilterGap=0.75rem  $opacityDisabled=0.45  $breakpoint-tablet=1440px */
.filter-panel {
  align-items: flex-end;
  margin-top: 0;
  margin-bottom: 0;
}

.filter-panel__actions {
  padding-right: 0.75rem;
}

.filter-panel__reset {
  white-space: nowrap;
}

:deep(.filter-panel__reset) {
  height: 56px;
  line-height: 1;
}

@media (max-width: 1440px) {
  .filter-panel__actions {
    justify-content: flex-start;
  }
}
</style>